import ColorPicker from '../../../components/ColorPicker';
import Subtitle from '../../../components/Header/Subtitle';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ShapeColorPicker = ({ selectedShape, t, setStageProperties, currentStage, setSelectedShape }) => {
    if (!selectedShape) return null;
    const handleChangeFill = (color, property) => {
        const colorValue = color.hex || color;
        setStageProperties((prevProperties) => {
            const updatedProperties = { ...prevProperties };
            const currentCombinedObject = updatedProperties[currentStage].combinedObject;
            const shapeIndex = currentCombinedObject.findIndex((shape) => shape.id === selectedShape.id);
            if (shapeIndex !== -1) {
                const updatedShape = { ...currentCombinedObject[shapeIndex] };
                updatedShape[property] = colorValue;
                if (property === 'fill' || property === 'stroke') {
                    setSelectedShape(updatedShape);
                }
                const updatedCombinedObject = [...currentCombinedObject];
                updatedCombinedObject[shapeIndex] = updatedShape;
                updatedProperties[currentStage].combinedObject = updatedCombinedObject;
            }
            return updatedProperties;
        });
    };
    const renderColorPickers = () => {
        if (selectedShape.property !== 'texts' && selectedShape.property !== 'resources') {
            return (
                <div>
                    <Subtitle name={'colors'} />
                    <p>{t('fill_color')}</p>
                    <ColorPicker
                        setColor={(color) => handleChangeFill(color, 'fill')}
                        color={selectedShape?.fill}
                        id='clp_scp_fill_color'
                    />
                    <p>{t('border_color')}</p>
                    <ColorPicker
                        setColor={(color) => handleChangeFill(color, 'stroke')}
                        color={selectedShape?.stroke}
                        id='clp_scp_border_color'
                    />
                </div>
            );
        } else if (selectedShape.property === 'texts') {
            return (
                <div className="mt-3 mb-5">
                    <p className='mb-3 title-property'>{t('text_color')}</p>
                    <ColorPicker
                        setColor={(color) => handleChangeFill(color, 'fill')}
                        color={selectedShape?.fill}
                        id='clp_scp_text_color'
                    />
                </div>
            );
        }
        return null;
    };

    return <div className='mt-3'>{renderColorPickers()}</div>;
};

export default ShapeColorPicker;
